import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const SearchIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.text.default,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C10.2958 15 11.4957 14.5892 12.4765 13.8907L15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L13.8907 12.4765C14.5892 11.4957 15 10.2958 15 9C15 5.68629 12.3137 3 9 3ZM4.5 9C4.5 6.51472 6.51472 4.5 9 4.5C11.4853 4.5 13.5 6.51472 13.5 9C13.5 11.4853 11.4853 13.5 9 13.5C6.51472 13.5 4.5 11.4853 4.5 9Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
